import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPayment = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.035 19.116C19.48 19.116 21 17.39 21 14.95V8.362c0-2.443-1.52-4.167-3.964-4.167H6.965C4.529 4.195 3 5.92 3 8.362v6.588c0 2.44 1.52 4.166 3.965 4.166M12 13.75v6.054"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m9.716 16.043 2.283-2.293 2.285 2.293M3 9.494h18"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPayment);
export default ForwardRef;
